var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRevenue = function SvgRevenue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 96 83"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#revenue_svg__a)",
    d: "M27.976 82.02c15.45 0 27.976-12.525 27.976-27.975S43.427 26.069 27.976 26.069 0 38.594 0 54.045 12.525 82.02 27.976 82.02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFFF",
    d: "M30.492 66.605c-2.405 0-4.42-.551-6.046-1.669s-2.863-2.601-3.692-4.468-1.22-3.933-1.22-6.213c0-2.387.39-4.545 1.186-6.458s2.032-3.412 3.709-4.53c1.676-1.117 3.793-1.667 6.368-1.667a12.45 12.45 0 0 1 5.809 1.423l-.61 3.871a12.8 12.8 0 0 0-2.54-1.01 10.1 10.1 0 0 0-2.744-.367c-2.337 0-4.132.75-5.352 2.25s-1.846 3.596-1.846 6.274c0 2.617.593 4.713 1.762 6.305 1.168 1.591 2.946 2.372 5.351 2.372a9.8 9.8 0 0 0 2.845-.398 12 12 0 0 0 2.575-1.087l.525 3.535c-.576.46-1.423.873-2.54 1.255-1.118.398-2.287.582-3.54.582"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFFF",
    d: "M33.173 50.692H14.988v2.728h18.185zM33.173 55.239H14.988v2.728h18.185z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B35DFF",
    d: "M67.396 55.952c15.451 0 27.976-12.525 27.976-27.976S82.847 0 67.396 0 39.42 12.525 39.42 27.976s12.526 27.976 27.976 27.976"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFFF",
    d: "M69.504 40.005c-2.405 0-4.42-.551-6.046-1.668s-2.862-2.602-3.692-4.469-1.22-3.932-1.22-6.213c0-2.387.39-4.545 1.186-6.457.796-1.913 2.032-3.413 3.709-4.53S67.234 15 69.809 15a12.45 12.45 0 0 1 5.809 1.423l-.61 3.872a12.8 12.8 0 0 0-2.54-1.01 10.1 10.1 0 0 0-2.744-.367c-2.337 0-4.132.75-5.352 2.25-1.219 1.499-1.846 3.595-1.846 6.273 0 2.617.593 4.714 1.762 6.305 1.168 1.592 2.947 2.372 5.351 2.372a9.8 9.8 0 0 0 2.846-.398 12 12 0 0 0 2.574-1.086l.525 3.535c-.576.459-1.423.872-2.54 1.254-1.118.398-2.287.582-3.54.582"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7EFFF",
    d: "M72.185 24.093H54v2.728h18.185zM72.185 28.64H54v2.727h18.185z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "revenue_svg__a",
    x1: 28.033,
    x2: 28.033,
    y1: 26.069,
    y2: 82.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7CC6",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })))));
};
export default SvgRevenue;